<template>
  <div class="your-us-address-component">
    <div class="flex items-center gap-4">
      <img v-if="isShipzee" class="h-5 w-5" :src="UsIcon" alt="US" />
      <span class="text-black dark:text-white font-bold">{{ t('site_pro.your_us_address') }}</span>
    </div>
    <div class="mt-4 flex flex-col gap-2 text-sm text-text1 dark:text-dmText1 wl:text-lg">
      <template v-if="client?.first_name || client?.last_name">
        <div class="font-bold">{{ fullName }}</div>
      </template>
      <div>{{ t('site_pro.address.street') }}</div>
      <div class="font-bold">{{ t('site_pro.address.suite') }} {{ suiteNumber }}</div>
      <div>{{ t('site_pro.address.city') }}</div>
      <div>{{ t('site_pro.address.phone') }}</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import UsIcon from '~/assets/icons/US.svg'
import { useIdentity } from '~/store/identity'
import ProEnum from '~/enums/ProEnum'

const { t } = useLang()

const identityStore = useIdentity()
const { isShipzee } = useTheme()

const client = await identityStore.getUser()

const fullName = computed(() => `${client?.first_name ?? ''} ${client?.last_name ?? ''}`)
const suiteNumber = computed(() => `${ProEnum.SuitePrefix}${client?.suit_number ?? ''}`)
</script>

<style>
.your-us-address-component {
  @apply flex flex-col w-full;
}
</style>

<style>
.wl {
  .your-us-address-component {
    @apply text-lg;
  }
}
</style>
